import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";

import { Partner, ServiceCategoryCard } from "@customTypes/partner";

interface MutationProps {
  partnerId: string;
  categories: ServiceCategoryCard[];
}

export const useUpdatePartnerServiceCategories = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async ({ partnerId, categories }: MutationProps) => {
      const { data } = await api.patch<Partner>(`partners/${partnerId}/service-categories`, categories);
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Service categories updated successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.partners(),
      });
    },
    onError: (res: any) => {
      console.error("[From Update Partner Service Categories Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
